import { GetterTree } from 'vuex';
import { ProductsState, RootState } from '@/types';

const getters: GetterTree<ProductsState, RootState> = {
  drones: (state) => ({
    isDisplayed: state.drones.isDisplayed,
    items: [...state.drones.items, ...state.centralBodies.items],
  }),
  accessories: (state) => ({
    isDisplayed: state.accessories.isDisplayed,
    items: [...state.accessories.items, ...state.spareParts.items],
  }),
  software: (state) => state.software,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/products/getters.ts